import { IGetAllInspecaoObraUseCase } from "../../../presentation/useCases/read/get_all_inspecao_obra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { InspecaoObra } from "../../models/inspecao_obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllInspecaoObraUseCase
 */

export class GetAllInspecaoObraUseCase extends BasePaginatedUseCase<InspecaoObra> implements IGetAllInspecaoObraUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllInspecaoObra(
    idObraChecklistServico: number | undefined,
    data: Date | null,
    localizacao: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObraChecklistServico === undefined) throw new Error('Id de checklist de serviço!');

    const response = await this.repository
      .getAllInspecaoObra(
        idObraChecklistServico,
        data,
        localizacao,
        status,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
